/**
 * Utilidades de procesamiento de imágenes en cliente
 *
 * @module imageUtils
 */

/**
 * Comprime una imagen reduciendo su resolución máxima y calidad JPEG.
 * Reduce a 1920px máx en el lado más largo, 82% calidad.
 * Imágenes ya dentro del límite se devuelven sin modificar.
 *
 * @param {File} rawFile - Archivo de imagen a comprimir
 * @returns {Promise<File>} Archivo comprimido o el original si no se pudo comprimir
 */
export function compressImage(rawFile) {
  return new Promise((resolve) => {
    const MAX_PX = 1920;
    const QUALITY = 0.82;
    const img = new Image();
    const objectUrl = URL.createObjectURL(rawFile);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      try {
        let { width, height } = img;
        if (width <= MAX_PX && height <= MAX_PX) { resolve(rawFile); return; }
        if (width > height) { height = Math.round(height * MAX_PX / width); width = MAX_PX; }
        else { width = Math.round(width * MAX_PX / height); height = MAX_PX; }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) { resolve(rawFile); return; }
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          if (!blob) { resolve(rawFile); return; }
          resolve(new File([blob], rawFile.name, { type: 'image/jpeg', lastModified: Date.now() }));
        }, 'image/jpeg', QUALITY);
      } catch {
        resolve(rawFile);
      }
    };
    img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(rawFile); };
    img.src = objectUrl;
  });
}
